import React from 'react';
import Slide from '@mui/material/Slide';
import {
  StyledDialog,
  StyledAppBar,
  StyledToolbar,
  StyledTitle,
} from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MLFullScreenDialog({
  children,
  open = false,
  onClose,
  onExited,
  title = '',
  actions = null,
  disableEnforceFocus = false,
  'data-test-id': dataTestId,
}) {
  const transitionProps = onExited ? { onExited } : undefined;

  return (
    <div>
      <StyledDialog
        fullScreen
        open={open}
        onClose={onClose}
        slots={{ transition: Transition }}
        slotProps={{ transition: transitionProps }}
        disableEnforceFocus={disableEnforceFocus}
        data-test-id={dataTestId}
      >
        <StyledAppBar>
          <StyledToolbar>
            <StyledTitle variant="h6">{title}</StyledTitle>
            {actions}
          </StyledToolbar>
        </StyledAppBar>
        <div>{children}</div>
      </StyledDialog>
    </div>
  );
}
